<div class="container-idle">
    <div class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered product-favorite-modal">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>Producto favorito</h1>
                    <h1 style="left: 0;" class="i-hover">
                        <i class="fa fa-xmark" (click)="closeModal()"> </i>
                    </h1>
                </div>
                <div class="modal-body">
                    <app-loading-animation *ngIf="loading" [height]="'10rem'"> </app-loading-animation>
                    <ng-container *ngIf="!loading && product">
                        <h5 class="mb-3">
                            <i class="fa-solid fa-box"></i>
                            Producto seleccionado
                        </h5>
                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <label class="form-label text-muted">
                                            Código
                                        </label>
                                        <div>
                                            <strong>
                                                {{product.code || '--'}}
                                            </strong>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <label class="form-label text-muted">
                                            Código de barras
                                        </label>
                                        <div>
                                            <strong>
                                                {{product.barCode || '--'}}
                                            </strong>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <label class="form-label text-muted">
                                            Tipo
                                        </label>
                                        <div>
                                            <strong>
                                                {{product.type == 'b'
                                                    ? 'Bien'
                                                    : 'Servicio'}}
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm">
                                        <label class="form-label text-muted">
                                            Nombre
                                        </label>
                                        <div>
                                            <strong>
                                                {{product.name}}
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Bodegas Actuales -->
                        <h5 class="mb-2">Favorito actualmente en</h5>
                        <div class="mb-3" *ngIf="favoriteWarehouses.length > 0">
                            <div *ngFor="let warehouse of favoriteWarehouses" class="favorite-warehouse-item">
                                <div class="favorite-warehouse-info">
                                    <span class="favorite-warehouse-code" *ngIf="warehouse.code">
                                        {{warehouse.code}}
                                    </span>
                                    <span class="favorite-warehouse-name">
                                        {{warehouse.name}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="favoriteWarehouses.length == 0" class="text-muted mb-3">
                            <i class="fa fa-circle-info"></i>
                            Este producto todavía no está marcado como favorito en ninguna bodega.
                        </div>
                        <hr>

                        <!-- Agregar nueva bodega -->
                        <h5 class="mb-3"> Agregar a una bodega </h5>
                        <div class="form-group" *ngIf="availableWarehouses.length > 0">
                            <label for="warehouseFavorite" class="form-label">
                                Bodega
                                <span class="required">*</span>
                            </label>
                            <div *ngIf="availableWarehouses.length > 0">
                                <div class="warehouse-selection-header mb-2">

                                    <label class="form-label mb-0">
                                        Bodegas
                                        <span class="required">*</span>
                                    </label>

                                    <div class="warehouse-selection-actions">

                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            *ngIf="!areAllWarehousesSelected()"
                                            (click)="selectAllWarehouses()">

                                            <i class="fa fa-check-double"></i>
                                            SELECCIONAR TODAS

                                        </button>

                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-secondary"
                                            *ngIf="selectedWarehouses.length > 0"
                                            (click)="clearSelectedWarehouses()">

                                            LIMPIAR

                                        </button>

                                    </div>

                                </div>

                                <div class="text-muted mb-2">

                                    {{selectedWarehouses.length}}
                                    de
                                    {{availableWarehouses.length}}
                                    bodegas seleccionadas

                                </div>

                                <div class="warehouse-selection-list">

                                    <label
                                        *ngFor="let w of availableWarehouses"
                                        class="warehouse-selection-item"
                                        [class.selected]="isWarehouseSelected(w.id)">

                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            [checked]="isWarehouseSelected(w.id)"
                                            (change)="toggleWarehouse(w.id)">

                                        <div class="warehouse-selection-info">

                                            <span
                                                *ngIf="w.code"
                                                class="warehouse-selection-code">

                                                {{w.code}}

                                            </span>

                                            <span class="warehouse-selection-name">
                                                {{w.name}}
                                            </span>

                                        </div>

                                    </label>

                                </div>

                            </div>
                        </div>
                        <!-- Si ya esta en todas se muestra este mensaje -->
                        <div *ngIf="availableWarehouses.length == 0" class="alert alert-info">
                            <i class="fa fa-circle-info"></i>
                            Este producto ya se encuentra marcado como favorito en todas las bodegas disponibles.
                        </div>
                    </ng-container>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" [disabled]="saving" (click)="closeModal()">
                        CERRAR
                    </button>
                    <button
                        class="btn btn-warning"
                        *ngIf="availableWarehouses.length > 0"
                        [disabled]="selectedWarehouses.length === 0 || saving"
                        (click)="saveFavorite()">

                        <ng-container *ngIf="!saving">
                            <i class="fa fa-star"></i>
                        </ng-container>

                        <ng-container *ngIf="saving">
                            <span
                                class="spinner-border spinner-border-sm"
                                aria-hidden="true">
                            </span>
                        </ng-container>

                        AGREGAR A FAVORITOS

                        <span *ngIf="selectedWarehouses.length > 0">
                            ({{selectedWarehouses.length}})
                        </span>

                    </button>
                </div>
            </div>
        </div>
    </div>
</div>